import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { routes } from './event.routes';
import { EventListComponent } from './event-list/event-list.component';
import { EventListDefaultTableComponent } from './event-list/event-list-default-table/event-list-default-table.component';
import { EventListFinancialComponent } from './event-list/event-list-financial-table/event-list-financial.component';
import { EventComponent } from './event/event.component';
import { EventStore } from './service/event.store';
import { EventHttpService } from './service/event.http.service';
import { AddEventComponent } from './add-event/add-event.component';
import { BasicEventDataComponent } from './basic-event-data/basic-event-data.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { EventListStore } from './service/event-list.store';
import { EventsResolver } from './service/events.resolver';
import { EventResolver } from './event/event.resolver';
import { ContactLookupFormComponent } from './contact-lookup-form/contact-lookup-form.component';
import { CommissionComponent } from './payment/commission/commission.component';
import { PaymentReservationsComponent } from './payment/reservations/payment-reservations.component';
import { ReservationStore } from './service/reservation-store';
import { ReservationService } from './service/reservation-http-service';
import { PropertyLookupHttpService } from '../shared/lookup/property-lookup/property-lookup.http.service';
import { PropertyLookupStore } from '../shared/lookup/property-lookup/property-lookup.store';
import { ChildContactFormComponent } from './child-contact-form/child-contact-form.component';
import { StaySummaryComponent } from './payment/stay-summary/stay-summary.component';
import { AddPaymentComponent } from './payment/add-payment/add-payment.component';
import { PaymentStore } from './service/payment.store';
import { PaymentHttpService } from './service/payment.http.service';
import { AttachmentComponent } from './attachment/attachment.component';
import { AttachmentStore } from './service/attachment/attachment.store';
import { AttachmentHttpService } from './service/attachment/attachment.http.service';
import { AttachmentResolver } from './attachment/attachment.resolver';
import { EventNavComponent } from './event-nav/event-nav.component';
import { RsvpComponent } from './rsvp/rsvp.component';
import { RsvpListComponent } from './rsvp-list/rsvp-list.component';
import { RsvpStore } from './service/rsvp.store';
import { RsvpHttpService } from './service/rsvp.http.service';
import { RsvpListResolver } from './rsvp-list/rsvp-list.resolver';
import { ReservationFilterComponent } from './reservations/reservation-filter/reservation-filter.component';
import { ReservationPageComponent } from './reservations/reservation-page/reservation-page.component';
import { ReservationResolver } from './payment/reservation.resolver';
import { ReservationSummaryTableComponent } from './reservations/reservation-summary-table/reservation-summary-table.component';
import { ReservationCompareStore } from './service/reservation-compare-store';
import { ReservationCompareService } from './service/reservation-compare-http-service';
import { ReservationCompareResolver } from './reservations/reservation.compare.resolver';
import { AddRsvpComponent } from './add-rsvp/add-rsvp.component';
import { ReservationDetailTableComponent } from './reservations/reservation-detail-table/reservation-detail-table.component';
import { CurrencyPipe } from '@angular/common';
import { AdjustmentStore } from './service/adjustment.store';
import { AdjustmentHttpService } from './service/adjustment.http.service';
import { AdjustmentResolver } from './payment/adjustment.resolver';
import { PaymentRecordComponent } from './payment/payment-record/payment-record.component';
import { LatestPaymentResolver } from './payment/latest-payment.resolver';
import { PaymentsResolver } from './payment/payments.resolver';
import { PaymentAdjustmentEquationComponent } from './payment/payment-adjustment-calculation/payment-adjustment-equation.component';
import { PaymentModifierDisplayComponent } from './payment/payment-modifier-display-calculation/payment-modifier-display.component';
import { AutomaticPaymentToggleComponent } from 'app/event/payment/automatic-payment-toggle/automatic-payment-toggle.component';
import { GroupPayConfigStore } from './service/grouppay-config.store';
import { GroupPayConfigHttpService } from './service/grouppay-config.http.service';
import { EventSearchParametersStore } from './service/event-search-parameters.store';
import { DashboardComponent } from './dashboard/dashboard-page/dashboard.component';
import { CompletedUnpaidComponent } from './dashboard/completed-unpaid/completed-unpaid.component';
import { MissingAgencyComponent } from './dashboard/missing-agency/missing-agency.component';
import { CompletedUnpaidDashboardStore } from './service/completed-unpaid-dashboard.store';
import { DashboardTotalsHttpService } from './service/dashboard-totals.http.service';
import { CanDeactiveReservationDetailTable } from './reservations/reservation-detail-table/reservation-detail-can-deactive';
import { EventFilterUtilsService } from './service/event-filter-util-service';
import { EventMenuSearchFilterMapper } from '../menus/event-search-filter/event-menu-search-filter-mapper';
import { MissingAgencyDashboardStore } from './service/missing-agency-dashboard.store';
import { EventSearchFormsStore } from './service/event-search-forms.store';
import { PredefinedSearchService } from './service/predefined-search.service';


@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    AddEventComponent,
    BasicEventDataComponent,
    ContactFormComponent,
    ContactLookupFormComponent,
    EventListComponent,
    EventListDefaultTableComponent,
    EventListFinancialComponent,
    EventComponent,
    CommissionComponent,
    PaymentReservationsComponent,
    ChildContactFormComponent,
    StaySummaryComponent,
    AddPaymentComponent,
    AttachmentComponent,
    EventNavComponent,
    RsvpComponent,
    RsvpListComponent,
    AddRsvpComponent,
    ReservationFilterComponent,
    ReservationPageComponent,
    ReservationSummaryTableComponent,
    ReservationDetailTableComponent,
    PaymentRecordComponent,
    PaymentAdjustmentEquationComponent,
    PaymentModifierDisplayComponent,
    AutomaticPaymentToggleComponent,
    DashboardComponent,
    CompletedUnpaidComponent,
    MissingAgencyComponent
  ],
  providers: [
    AttachmentResolver,
    AttachmentStore,
    EventStore,
    EventListStore,
    EventHttpService,
    EventsResolver,
    EventResolver,
    AttachmentHttpService,
    PropertyLookupHttpService,
    PropertyLookupStore,
    ReservationService,
    ReservationResolver,
    ReservationStore,
    ReservationCompareService,
    ReservationCompareResolver,
    ReservationCompareStore,
    PaymentStore,
    PaymentHttpService,
    RsvpStore,
    RsvpHttpService,
    RsvpListResolver,
    CurrencyPipe,
    AdjustmentStore,
    AdjustmentHttpService,
    AdjustmentResolver,
    LatestPaymentResolver,
    PaymentsResolver,
    GroupPayConfigStore,
    GroupPayConfigHttpService,
    EventSearchParametersStore,
    CompletedUnpaidDashboardStore,
    MissingAgencyDashboardStore,
    DashboardTotalsHttpService,
    CanDeactiveReservationDetailTable,
    EventFilterUtilsService,
    EventMenuSearchFilterMapper,
    EventSearchFormsStore,
    PredefinedSearchService
  ]
})
export class EventModule {
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event.module.ts